var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"login"},[_c('div',{staticClass:"login__form"},[_c('LoginForm')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }